/**
 * Reusable Button Component
 * Button component احترافي مثل SaaS apps
 */
import React from 'react';
import styled from 'styled-components';

const StyledButton = styled.button`
  padding: ${props => {
    if (props.size === 'small') return '6px 12px';
    if (props.size === 'large') return '12px 24px';
    return '10px 20px';
  }};
  border: ${props => {
    if (props.variant === 'outline') return `1px solid ${props.theme.primary || '#007bff'}`;
    if (props.variant === 'ghost') return '1px solid transparent';
    return '1px solid transparent';
  }};
  border-radius: ${props => props.theme.radius?.md || '8px'};
  background-color: ${props => {
    if (props.variant === 'primary') return props.theme.primary || '#007bff';
    if (props.variant === 'danger') return props.theme.danger || '#dc3545';
    if (props.variant === 'success') return props.theme.success || '#28a745';
    if (props.variant === 'outline') return 'transparent';
    if (props.variant === 'ghost') return 'transparent';
    return props.theme.surface || '#f5f5f5';
  }};
  color: ${props => {
    if (props.variant === 'primary' || props.variant === 'danger' || props.variant === 'success') return '#fff';
    if (props.variant === 'outline') return props.theme.primary || '#007bff';
    return props.theme.text || '#000';
  }};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  opacity: ${props => props.disabled ? 0.6 : 1};
  font-size: ${props => {
    if (props.size === 'small') return props.theme.fontSize?.sm || '14px';
    if (props.size === 'large') return props.theme.fontSize?.lg || '18px';
    return props.theme.fontSize?.base || '16px';
  }};
  font-weight: 500;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${props => props.theme.spacing?.xs || '4px'};
  
  &:hover {
    ${props => !props.disabled && `
      ${props.variant === 'primary' ? `
        background-color: ${props.theme.primaryDark || '#0056b3'};
      ` : ''}
      ${props.variant === 'outline' ? `
        background-color: ${props.theme.primary || '#007bff'}10;
      ` : ''}
      ${props.variant === 'ghost' ? `
        background-color: ${props.theme.surface || '#f5f5f5'};
      ` : ''}
      transform: translateY(-1px);
      box-shadow: ${props.theme.shadow || '0 2px 4px rgba(0,0,0,0.1)'};
    `}
  }
  
  &:active {
    transform: ${props => props.disabled ? 'none' : 'translateY(0)'};
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px ${props => props.theme.primary || '#007bff'}30;
  }
`;

export const Button = ({ 
  children, 
  onClick, 
  disabled = false, 
  variant = 'default',
  size = 'medium',
  icon,
  fullWidth = false,
  ...props 
}) => {
  return (
    <StyledButton
      onClick={onClick}
      disabled={disabled}
      variant={variant}
      size={size}
      style={{ width: fullWidth ? '100%' : 'auto' }}
      {...props}
    >
      {icon && icon}
      {children}
    </StyledButton>
  );
};

